import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformSuperuserRole } from './superuser-roles.transformers';
import { SuperuserRolesCollection } from './superuser-roles.types';

export function superuserRolesReducer(
  state: CollectionStateSlice<SuperuserRolesCollection> = {},
  action: CollectionActions<SuperuserRolesCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'superuserRoles') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<SuperuserRolesCollection>(
          state,
          transformIntoDocuments(result.roles, transformSuperuserRole),
          order,
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
}
